import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { Input, InputWithOptions, Button } from 'wix-style-react'
import _ from 'lodash'
import FaCheck from 'react-icons/lib/fa/check'

import * as integrationType from 'constants/integrationType'
import { LIGHTEST_GRAY, BLUE } from '../styles'
import { SHOPIFY_POPUP } from 'constants/index'
import { setCustomFieldArray } from 'controllers/logic'
import Text from 'components/common/Text'

const TitleInput = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 5px;
  width: 100%;
`
const Divider = styled.div`
  height: 1px;
  background-color: ${LIGHTEST_GRAY};
  margin: 20px 0px 20px 0px;
`
const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`
const CheckContainer = styled.div`
  height: 100%;
`
const InputContainer = styled.div`
  width: 70%;
`
const InputOption = styled.div`
  margin-left: 1em
`

class ShopifyConnect extends Component {

  constructor (props) {
    super(props)
    this.state = {
      shop: (props.shopName) ? props.shopName : ''
    }
    this.makeExistingIntegrations(props.apps)
  }

  renderInputOption (text) {
    return (
      <InputOption>
        <Text>{text}</Text>
      </InputOption>
    )
  }

  makeExistingIntegrations = (apps) => {
    this.existingIntegrations = []
    const shopNames = []
    for (const appId in apps) {
      const app = apps[appId]
      const integration = _.get(app, ['customFields', 'appSettings', 'integration'])
      if (integration && integration.type === integrationType.SHOPIFY) {
        if (_.indexOf(shopNames, integration.shopName) < 0) {
          const option = {
            id: this.existingIntegrations.length,
            value: this.renderInputOption(integration.shopName),
            integration: _.clone(integration)
          }
          shopNames.push(integration.shopName)
          this.existingIntegrations.push(option)
        }
      }
    }
  }

  onInputChange = (e) => {
    this.setState({
      shop: e.target.value
    })
  }

  connect = () => {
    const { user, appId, dispatch } = this.props
    const { shop } = this.state
    let existingIntegration
    for (const o of this.existingIntegrations) {
      if (o.integration.shopName === shop) existingIntegration = o.integration
    }
    if (existingIntegration) {
      dispatch(setCustomFieldArray(appId, ['appSettings', 'integration'], existingIntegration))
    } else {
      const uri = `${SHOPIFY_POPUP}?user_id=${user.id}&app_id=${appId}&shop=${shop}`
      window.open(uri, 'Shopify connect')
    }
  }

  renderCheck () {
    if (this.props.shopName === this.state.shop && !_.isNil(this.props.accessToken)) {
      return (
        <CheckContainer>
          <FaCheck color={BLUE} />
        </CheckContainer>
      )
    }
  }

  renderButton () {
    const { shop } = this.state
    if (this.props.shopName !== shop) {
      return (
        <Button
          onClick={this.connect}
          disabled={_.isNil(shop) || shop === ''}
        >
          Connect
        </Button>
      )
    }
  }

  onOptionSelect = (option) => {
    // console.log('onOptionSelect', option)
    if (option) {
      this.setState({
        shop: option.integration.shopName
      })
    }
  }

  renderInput () {
    if (this.existingIntegrations.length > 0) {
      // console.log('existingIntegrations', this.existingIntegrations)
      return (
        <InputWithOptions
          options={this.existingIntegrations}
          size='normal'
          prefix={<Text size='medium'>https:// </Text>}
          suffix={<Text size='medium'>.myshopify.com</Text>}
          value={this.state.shop}
          onChange={this.onInputChange}
          maxLength={75}
          onSelect={this.onOptionSelect}
        />
      )
    } else {
      return (
        <Input
          size='normal'
          prefix={<Text size='medium'>https:// </Text>}
          suffix={<Text size='medium'>.myshopify.com</Text>}
          value={this.state.shop}
          onChange={this.onInputChange}
          maxLength={75}
        />
      )
    }
  }

  render () {
    const { showDivider } = this.props
    return (
      <div>
        <TitleInput>
          <Text size='medium'>URL of your Shopify Shop</Text>
          <Container>
            <InputContainer>
              {this.renderInput()}
            </InputContainer>
            {this.renderCheck()}
            {this.renderButton()}
          </Container>
        </TitleInput>
        { showDivider ? <Divider /> : null }
      </div>
    )
  }
}

ShopifyConnect.defaultProps = {
  showDivider: true
}

ShopifyConnect.propTypes = {
  appId: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
  shopName: PropTypes.string,
  accessToken: PropTypes.string,
  showDivider: PropTypes.bool,
  apps: PropTypes.object.isRequired
}

const mapStateToProps = (state) => ({
  user: state.user,
  apps: state.apps
})

export default connect(mapStateToProps)(ShopifyConnect)



// WEBPACK FOOTER //
// ./src/components/integrations/ShopifyConnect.js